/**
 * Al Haramain Mart — Expat (প্রবাসী) COD Detection + eSolver COD Checkout Field Injector
 * ---------------------------------------------------------------------------------
 * eSolver COD Checkout-এর popup-এর জন্য rebuild করা (আগে Releasit COD Form-এর জন্য
 * বানানো হয়েছিল, DOM structure সম্পূর্ণ ভিন্ন হওয়ায় নতুন করে লেখা হলো)।
 *
 * eSolver-এর মূল field-গুলোর id/data-field র‍্যান্ডম হ্যাশ (যেমন
 * "field-cmu9s815j023qkgkmcsddfrjt") — এগুলো store-এ field reconfigure করলে
 * বদলে যেতে পারে। তাই এই script main field খুঁজে বের করে POSITION (ক্রম) দিয়ে —
 * ১ম = নাম, ২য় = মোবাইল, ৩য় = ঠিকানা। ব্যতিক্রম শুধু Order Note field
 * (id="field-order_note") — এটা eSolver-এর নিজস্ব fixed/বিশেষ field, তাই
 * নিরাপদে সরাসরি id দিয়ে টার্গেট করা যায়।
 *
 * ইনস্টল: theme.liquid-এ </body>-এর আগে —
 * <script src="{{ 'expat-cod-injector.js' | asset_url }}" defer></script>
 */

(function () {
  "use strict";

  /* ---------- STEP 0: এক-বারের CSS style injection ---------- */
  function injectStylesOnce() {
    if (document.getElementById("ahm-expat-styles")) return;
    var style = document.createElement("style");
    style.id = "ahm-expat-styles";
    style.textContent =
      ".ahm-whatsapp-row{display:flex;gap:8px;}" +
      ".ahm-whatsapp-row select,.ahm-whatsapp-row input{flex:1 1 0;min-width:0;}" +
      "@media (max-width:640px){" +
      ".ahm-whatsapp-row{flex-direction:column;gap:8px;}" +
      ".ahm-whatsapp-row select,.ahm-whatsapp-row input{width:100%;flex:1 1 100%;}" +
      "}" +
      ".ahm-expat-note-highlight{" +
      "background:#fff7e6;border-left:4px solid #f5a623;border-radius:6px;" +
      "padding:10px 12px;margin:6px 0 14px;font-size:13.5px;font-weight:600;" +
      "color:#7a4a00;line-height:1.5;}" +
      ".ahm-required-star{color:#d02222;margin-left:2px;}";
    document.head.appendChild(style);
  }
  injectStylesOnce();

  /* ---------- STEP 1: Country Detection ---------- */

  var STORAGE_KEY = "ahm_visitor_country";
  var BD_CODE = "BD";

  function detectCountry() {
    return new Promise(function (resolve) {
      var cached = sessionStorage.getItem(STORAGE_KEY);
      if (cached) {
        resolve(cached);
        return;
      }
      fetch("https://ipapi.co/json/", { cache: "no-store" })
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          var code = (data && data.country_code) || BD_CODE;
          sessionStorage.setItem(STORAGE_KEY, code);
          resolve(code);
        })
        .catch(function () {
          resolve(BD_CODE);
        });
    });
  }

  var countryPromise = detectCountry();
  var resolvedCountryIso = null;
  countryPromise.then(function (code) {
    resolvedCountryIso = code;
  });

  /* ---------- Field IDs / Keys ---------- */

  var NAME_FIELD_ID = "ahm-expat-name";
  var WHATSAPP_FIELD_ID = "ahm-expat-whatsapp";
  var WHATSAPP_CC_ID = "ahm-expat-whatsapp-cc";
  var DETECTED_COUNTRY_FIELD_ID = "ahm-expat-detected-country";
  var CONTACT_TYPE_ID = "ahm-expat-contact-type";
  var BLOCK_ATTR = "data-ahm-expat-block";

  // eSolver-এর নিজস্ব fixed field — এটা random hash না, নিরাপদে সরাসরি id দিয়ে ব্যবহারযোগ্য
  var ESOLVER_NOTE_FIELD_ID = "field-order_note";
  var ESOLVER_SUBMIT_BTN_ID = "submit-btn";

  function isoToFlag(iso) {
    return iso.replace(/./g, function (c) {
      return String.fromCodePoint(127397 + c.charCodeAt(0));
    });
  }

  var PRIORITY_COUNTRIES = [
    { iso: "SA", name: "Saudi Arabia", dial: "+966" },
    { iso: "AE", name: "United Arab Emirates", dial: "+971" },
    { iso: "OM", name: "Oman", dial: "+968" },
    { iso: "QA", name: "Qatar", dial: "+974" },
    { iso: "KW", name: "Kuwait", dial: "+965" },
    { iso: "BH", name: "Bahrain", dial: "+973" },
    { iso: "LB", name: "Lebanon", dial: "+961" },
    { iso: "PK", name: "Pakistan", dial: "+92" },
    { iso: "MY", name: "Malaysia", dial: "+60" },
    { iso: "SG", name: "Singapore", dial: "+65" },
    { iso: "MV", name: "Maldives", dial: "+960" },
    { iso: "IN", name: "India", dial: "+91" },
    { iso: "GB", name: "United Kingdom", dial: "+44" },
    { iso: "US", name: "United States", dial: "+1" },
    { iso: "IT", name: "Italy", dial: "+39" },
    { iso: "CA", name: "Canada", dial: "+1" },
    { iso: "GR", name: "Greece", dial: "+30" },
    { iso: "ES", name: "Spain", dial: "+34" },
    { iso: "AU", name: "Australia", dial: "+61" },
    { iso: "BN", name: "Brunei", dial: "+673" },
    { iso: "PT", name: "Portugal", dial: "+351" },
    { iso: "MU", name: "Mauritius", dial: "+230" },
    { iso: "JP", name: "Japan", dial: "+81" },
    { iso: "KR", name: "South Korea", dial: "+82" },
    { iso: "DE", name: "Germany", dial: "+49" },
    { iso: "BR", name: "Brazil", dial: "+55" },
    { iso: "NO", name: "Norway", dial: "+47" },
    { iso: "ZA", name: "South Africa", dial: "+27" },
    { iso: "LY", name: "Libya", dial: "+218" }
  ];

  var OTHER_COUNTRIES = [
    { iso: "AF", name: "Afghanistan", dial: "+93" },
    { iso: "AL", name: "Albania", dial: "+355" },
    { iso: "DZ", name: "Algeria", dial: "+213" },
    { iso: "AD", name: "Andorra", dial: "+376" },
    { iso: "AO", name: "Angola", dial: "+244" },
    { iso: "AG", name: "Antigua and Barbuda", dial: "+1" },
    { iso: "AR", name: "Argentina", dial: "+54" },
    { iso: "AM", name: "Armenia", dial: "+374" },
    { iso: "AW", name: "Aruba", dial: "+297" },
    { iso: "AT", name: "Austria", dial: "+43" },
    { iso: "AZ", name: "Azerbaijan", dial: "+994" },
    { iso: "BS", name: "Bahamas", dial: "+1" },
    { iso: "BB", name: "Barbados", dial: "+1" },
    { iso: "BY", name: "Belarus", dial: "+375" },
    { iso: "BE", name: "Belgium", dial: "+32" },
    { iso: "BZ", name: "Belize", dial: "+501" },
    { iso: "BJ", name: "Benin", dial: "+229" },
    { iso: "BT", name: "Bhutan", dial: "+975" },
    { iso: "BO", name: "Bolivia", dial: "+591" },
    { iso: "BA", name: "Bosnia and Herzegovina", dial: "+387" },
    { iso: "BW", name: "Botswana", dial: "+267" },
    { iso: "BG", name: "Bulgaria", dial: "+359" },
    { iso: "BF", name: "Burkina Faso", dial: "+226" },
    { iso: "BI", name: "Burundi", dial: "+257" },
    { iso: "KH", name: "Cambodia", dial: "+855" },
    { iso: "CM", name: "Cameroon", dial: "+237" },
    { iso: "CV", name: "Cape Verde", dial: "+238" },
    { iso: "CF", name: "Central African Republic", dial: "+236" },
    { iso: "TD", name: "Chad", dial: "+235" },
    { iso: "CL", name: "Chile", dial: "+56" },
    { iso: "CN", name: "China", dial: "+86" },
    { iso: "CO", name: "Colombia", dial: "+57" },
    { iso: "KM", name: "Comoros", dial: "+269" },
    { iso: "CG", name: "Congo", dial: "+242" },
    { iso: "CD", name: "DR Congo", dial: "+243" },
    { iso: "CR", name: "Costa Rica", dial: "+506" },
    { iso: "HR", name: "Croatia", dial: "+385" },
    { iso: "CU", name: "Cuba", dial: "+53" },
    { iso: "CY", name: "Cyprus", dial: "+357" },
    { iso: "CZ", name: "Czech Republic", dial: "+420" },
    { iso: "DK", name: "Denmark", dial: "+45" },
    { iso: "DJ", name: "Djibouti", dial: "+253" },
    { iso: "DM", name: "Dominica", dial: "+1" },
    { iso: "DO", name: "Dominican Republic", dial: "+1" },
    { iso: "EC", name: "Ecuador", dial: "+593" },
    { iso: "EG", name: "Egypt", dial: "+20" },
    { iso: "SV", name: "El Salvador", dial: "+503" },
    { iso: "GQ", name: "Equatorial Guinea", dial: "+240" },
    { iso: "ER", name: "Eritrea", dial: "+291" },
    { iso: "EE", name: "Estonia", dial: "+372" },
    { iso: "SZ", name: "Eswatini", dial: "+268" },
    { iso: "ET", name: "Ethiopia", dial: "+251" },
    { iso: "FJ", name: "Fiji", dial: "+679" },
    { iso: "FI", name: "Finland", dial: "+358" },
    { iso: "FR", name: "France", dial: "+33" },
    { iso: "GA", name: "Gabon", dial: "+241" },
    { iso: "GM", name: "Gambia", dial: "+220" },
    { iso: "GE", name: "Georgia", dial: "+995" },
    { iso: "GH", name: "Ghana", dial: "+233" },
    { iso: "GD", name: "Grenada", dial: "+1" },
    { iso: "GT", name: "Guatemala", dial: "+502" },
    { iso: "GN", name: "Guinea", dial: "+224" },
    { iso: "GW", name: "Guinea-Bissau", dial: "+245" },
    { iso: "GY", name: "Guyana", dial: "+592" },
    { iso: "HT", name: "Haiti", dial: "+509" },
    { iso: "HN", name: "Honduras", dial: "+504" },
    { iso: "HK", name: "Hong Kong", dial: "+852" },
    { iso: "HU", name: "Hungary", dial: "+36" },
    { iso: "IS", name: "Iceland", dial: "+354" },
    { iso: "ID", name: "Indonesia", dial: "+62" },
    { iso: "IR", name: "Iran", dial: "+98" },
    { iso: "IQ", name: "Iraq", dial: "+964" },
    { iso: "IE", name: "Ireland", dial: "+353" },
    { iso: "IL", name: "Israel", dial: "+972" },
    { iso: "JM", name: "Jamaica", dial: "+1" },
    { iso: "JO", name: "Jordan", dial: "+962" },
    { iso: "KZ", name: "Kazakhstan", dial: "+7" },
    { iso: "KE", name: "Kenya", dial: "+254" },
    { iso: "KI", name: "Kiribati", dial: "+686" },
    { iso: "XK", name: "Kosovo", dial: "+383" },
    { iso: "KP", name: "North Korea", dial: "+850" },
    { iso: "KG", name: "Kyrgyzstan", dial: "+996" },
    { iso: "LA", name: "Laos", dial: "+856" },
    { iso: "LV", name: "Latvia", dial: "+371" },
    { iso: "LS", name: "Lesotho", dial: "+266" },
    { iso: "LR", name: "Liberia", dial: "+231" },
    { iso: "LI", name: "Liechtenstein", dial: "+423" },
    { iso: "LT", name: "Lithuania", dial: "+370" },
    { iso: "LU", name: "Luxembourg", dial: "+352" },
    { iso: "MO", name: "Macau", dial: "+853" },
    { iso: "MG", name: "Madagascar", dial: "+261" },
    { iso: "MW", name: "Malawi", dial: "+265" },
    { iso: "ML", name: "Mali", dial: "+223" },
    { iso: "MT", name: "Malta", dial: "+356" },
    { iso: "MH", name: "Marshall Islands", dial: "+692" },
    { iso: "MR", name: "Mauritania", dial: "+222" },
    { iso: "MX", name: "Mexico", dial: "+52" },
    { iso: "FM", name: "Micronesia", dial: "+691" },
    { iso: "MD", name: "Moldova", dial: "+373" },
    { iso: "MC", name: "Monaco", dial: "+377" },
    { iso: "MN", name: "Mongolia", dial: "+976" },
    { iso: "ME", name: "Montenegro", dial: "+382" },
    { iso: "MA", name: "Morocco", dial: "+212" },
    { iso: "MZ", name: "Mozambique", dial: "+258" },
    { iso: "MM", name: "Myanmar", dial: "+95" },
    { iso: "NA", name: "Namibia", dial: "+264" },
    { iso: "NR", name: "Nauru", dial: "+674" },
    { iso: "NP", name: "Nepal", dial: "+977" },
    { iso: "NL", name: "Netherlands", dial: "+31" },
    { iso: "NZ", name: "New Zealand", dial: "+64" },
    { iso: "NI", name: "Nicaragua", dial: "+505" },
    { iso: "NE", name: "Niger", dial: "+227" },
    { iso: "NG", name: "Nigeria", dial: "+234" },
    { iso: "MK", name: "North Macedonia", dial: "+389" },
    { iso: "PW", name: "Palau", dial: "+680" },
    { iso: "PS", name: "Palestine", dial: "+970" },
    { iso: "PA", name: "Panama", dial: "+507" },
    { iso: "PG", name: "Papua New Guinea", dial: "+675" },
    { iso: "PY", name: "Paraguay", dial: "+595" },
    { iso: "PE", name: "Peru", dial: "+51" },
    { iso: "PH", name: "Philippines", dial: "+63" },
    { iso: "PL", name: "Poland", dial: "+48" },
    { iso: "RO", name: "Romania", dial: "+40" },
    { iso: "RU", name: "Russia", dial: "+7" },
    { iso: "RW", name: "Rwanda", dial: "+250" },
    { iso: "KN", name: "Saint Kitts and Nevis", dial: "+1" },
    { iso: "LC", name: "Saint Lucia", dial: "+1" },
    { iso: "VC", name: "Saint Vincent and the Grenadines", dial: "+1" },
    { iso: "WS", name: "Samoa", dial: "+685" },
    { iso: "SM", name: "San Marino", dial: "+378" },
    { iso: "ST", name: "Sao Tome and Principe", dial: "+239" },
    { iso: "SN", name: "Senegal", dial: "+221" },
    { iso: "RS", name: "Serbia", dial: "+381" },
    { iso: "SC", name: "Seychelles", dial: "+248" },
    { iso: "SL", name: "Sierra Leone", dial: "+232" },
    { iso: "SK", name: "Slovakia", dial: "+421" },
    { iso: "SI", name: "Slovenia", dial: "+386" },
    { iso: "SB", name: "Solomon Islands", dial: "+677" },
    { iso: "SO", name: "Somalia", dial: "+252" },
    { iso: "LK", name: "Sri Lanka", dial: "+94" },
    { iso: "SD", name: "Sudan", dial: "+249" },
    { iso: "SR", name: "Suriname", dial: "+597" },
    { iso: "SE", name: "Sweden", dial: "+46" },
    { iso: "CH", name: "Switzerland", dial: "+41" },
    { iso: "SY", name: "Syria", dial: "+963" },
    { iso: "TW", name: "Taiwan", dial: "+886" },
    { iso: "TJ", name: "Tajikistan", dial: "+992" },
    { iso: "TZ", name: "Tanzania", dial: "+255" },
    { iso: "TH", name: "Thailand", dial: "+66" },
    { iso: "TL", name: "Timor-Leste", dial: "+670" },
    { iso: "TG", name: "Togo", dial: "+228" },
    { iso: "TO", name: "Tonga", dial: "+676" },
    { iso: "TT", name: "Trinidad and Tobago", dial: "+1" },
    { iso: "TN", name: "Tunisia", dial: "+216" },
    { iso: "TR", name: "Turkey", dial: "+90" },
    { iso: "TM", name: "Turkmenistan", dial: "+993" },
    { iso: "TV", name: "Tuvalu", dial: "+688" },
    { iso: "UG", name: "Uganda", dial: "+256" },
    { iso: "UA", name: "Ukraine", dial: "+380" },
    { iso: "UY", name: "Uruguay", dial: "+598" },
    { iso: "UZ", name: "Uzbekistan", dial: "+998" },
    { iso: "VU", name: "Vanuatu", dial: "+678" },
    { iso: "VA", name: "Vatican City", dial: "+379" },
    { iso: "VE", name: "Venezuela", dial: "+58" },
    { iso: "VN", name: "Vietnam", dial: "+84" },
    { iso: "YE", name: "Yemen", dial: "+967" },
    { iso: "ZM", name: "Zambia", dial: "+260" },
    { iso: "ZW", name: "Zimbabwe", dial: "+263" }
  ];

  function countryNameFromIso(iso) {
    if (!iso) return "-";
    var all = PRIORITY_COUNTRIES.concat(OTHER_COUNTRIES);
    for (var i = 0; i < all.length; i++) {
      if (all[i].iso === iso) return all[i].name;
    }
    return iso;
  }

  function buildOptions(list) {
    return list
      .map(function (c) {
        return (
          '<option value="' +
          c.dial +
          '" data-iso="' +
          c.iso +
          '">' +
          isoToFlag(c.iso) +
          " " +
          c.name +
          " (" +
          c.dial +
          ")</option>"
        );
      })
      .join("");
  }

  /* ---------- STEP 2: Field HTML (eSolver-এর নিজস্ব class scheme ব্যবহার করে, যাতে দেখতে মিলে যায়) ---------- */

  function nameFieldHTML() {
    return (
      '<div class="esolver-cod-field esolver-cod-field--std" ' +
      BLOCK_ATTR +
      '="true">' +
      '<label class="esolver-cod-label">প্রবাসীর নাম' +
      '<span class="ahm-required-star">*</span></label>' +
      '<div class="esolver-cod-control">' +
      '<input type="text" class="esolver-cod-bare esolver-cod-input" ' +
      'id="' +
      NAME_FIELD_ID +
      '" placeholder="প্রবাসীর নাম লিখুন">' +
      "</div>" +
      "</div>"
    );
  }

  function whatsappFieldHTML() {
    var priorityOptions = buildOptions(PRIORITY_COUNTRIES);
    var otherOptions = buildOptions(OTHER_COUNTRIES);

    return (
      '<div class="esolver-cod-field esolver-cod-field--std" ' +
      BLOCK_ATTR +
      '="true">' +
      '<label class="esolver-cod-label">প্রবাসী WhatsApp / IMO নম্বর' +
      '<span class="ahm-required-star">*</span></label>' +
      '<div style="font-size:12.5px;color:#666;margin:-2px 0 8px;">' +
      "যেকোনো একটি নম্বর দিন — WhatsApp অথবা IMO, দুটোর জন্য একই নম্বর হলেও সমস্যা নেই।" +
      "</div>" +
      '<div class="ahm-contact-type-toggle" style="display:flex;gap:8px;margin-bottom:8px;">' +
      '<button type="button" data-contact-type="WhatsApp" ' +
      'class="ahm-toggle-btn ahm-toggle-active" ' +
      'style="flex:1;padding:8px;border-radius:6px;border:1.5px solid #25D366;' +
      'background:#25D366;color:#fff;font-size:13px;font-weight:600;cursor:pointer;">' +
      "WhatsApp</button>" +
      '<button type="button" data-contact-type="IMO" ' +
      'class="ahm-toggle-btn" ' +
      'style="flex:1;padding:8px;border-radius:6px;border:1.5px solid #ccc;' +
      'background:#fff;color:#555;font-size:13px;font-weight:600;cursor:pointer;">' +
      "IMO</button>" +
      "</div>" +
      '<input type="hidden" id="' +
      CONTACT_TYPE_ID +
      '" value="WhatsApp">' +
      '<div class="ahm-whatsapp-row">' +
      '<select id="' +
      WHATSAPP_CC_ID +
      '" style="border:1px solid #ccc;border-radius:6px;padding:8px 6px;background:#fff;font-size:13px;">' +
      '<optgroup label="বেশি ব্যবহৃত দেশ">' +
      priorityOptions +
      "</optgroup>" +
      '<optgroup label="অন্যান্য সব দেশ">' +
      otherOptions +
      "</optgroup>" +
      "</select>" +
      '<input type="tel" class="esolver-cod-bare esolver-cod-input" ' +
      'placeholder="নম্বর লিখুন (কোড ছাড়া)" ' +
      'id="' +
      WHATSAPP_FIELD_ID +
      '" style="border:1px solid #ccc;border-radius:6px;padding:8px 12px;font-size:14px;">' +
      "</div>" +
      "</div>"
    );
  }

  function noteTextHTML() {
    return (
      "<div " +
      BLOCK_ATTR +
      '="true" class="ahm-expat-note-highlight">' +
      "📢 আপনার পরিবারকে অর্ডারের বিষয়ে দ্রুত জানিয়ে দিবেন, প্লিজ।" +
      "</div>"
    );
  }

  function detectedCountryFieldHTML() {
    return (
      '<input type="hidden" id="' + DETECTED_COUNTRY_FIELD_ID + '" value="">'
    );
  }

  /* ---------- STEP 3: eSolver-এর মূল ৩টা field খুঁজে বের করা (position দিয়ে) ---------- */

  function getMainFieldContainers() {
    var all = Array.prototype.slice.call(
      document.querySelectorAll(".esolver-cod-field.esolver-cod-field--std")
    );
    // Order Note field-এরও একই class আছে, তাই সেটা বাদ দিচ্ছি
    return all.filter(function (el) {
      return !el.querySelector('[data-field="order_note"]');
    });
  }

  function injectFields(addressContainer, detectedIso) {
    if (document.getElementById(NAME_FIELD_ID)) return;

    var wrapper = document.createElement("div");
    wrapper.setAttribute(BLOCK_ATTR + "-wrapper", "true");
    wrapper.innerHTML =
      nameFieldHTML() +
      whatsappFieldHTML() +
      noteTextHTML() +
      detectedCountryFieldHTML();

    addressContainer.parentNode.insertBefore(
      wrapper,
      addressContainer.nextSibling
    );

    var hiddenCountry = document.getElementById(DETECTED_COUNTRY_FIELD_ID);
    if (hiddenCountry) hiddenCountry.value = detectedIso || "";

    var ccSelect = document.getElementById(WHATSAPP_CC_ID);
    if (ccSelect && detectedIso) {
      var match = ccSelect.querySelector(
        'option[data-iso="' + detectedIso + '"]'
      );
      if (match) ccSelect.value = match.value;
    }

    var toggleButtons = wrapper.querySelectorAll(".ahm-toggle-btn");
    var contactTypeField = document.getElementById(CONTACT_TYPE_ID);
    var telInput = document.getElementById(WHATSAPP_FIELD_ID);
    toggleButtons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var type = btn.getAttribute("data-contact-type");
        if (contactTypeField) contactTypeField.value = type;
        if (telInput) {
          telInput.placeholder =
            type === "IMO"
              ? "IMO নম্বর লিখুন (কোড ছাড়া)"
              : "নম্বর লিখুন (কোড ছাড়া)";
        }
        toggleButtons.forEach(function (b) {
          var isActive = b === btn;
          if (isActive) {
            b.style.background = "#25D366";
            b.style.color = "#fff";
            b.style.borderColor = "#25D366";
          } else {
            b.style.background = "#fff";
            b.style.color = "#555";
            b.style.borderColor = "#ccc";
          }
        });
      });
    });
  }

  function removeInjectedFields() {
    document
      .querySelectorAll("[" + BLOCK_ATTR + "], [" + BLOCK_ATTR + "-wrapper]")
      .forEach(function (el) {
        el.remove();
      });
  }

  function handlePopupOpen() {
    var mainFields = getMainFieldContainers();
    if (mainFields.length < 3) return; // popup এখনো সম্পূর্ণ রেন্ডার হয়নি

    var addressContainer = mainFields[2]; // ৩য় field = ঠিকানা

    countryPromise.then(function (code) {
      var isExpat = code && code !== BD_CODE;
      if (isExpat) {
        injectFields(addressContainer, code);
      } else {
        removeInjectedFields();
      }
    });
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (
          (node.querySelector &&
            node.querySelector(".esolver-cod-field--std")) ||
          (node.classList && node.classList.contains("esolver-cod-field--std"))
        ) {
          handlePopupOpen();
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  /* ---------- STEP 4: Submit বাটনের ঠিক আগে — validate + note বসানো ---------- */
  // eSolver-এর বাটন type="button" (native submit না), তাই click শুনি,
  // capture phase-এ, eSolver-এর নিজের handler-এর আগে।

  document.addEventListener(
    "click",
    function (e) {
      var trigger = e.target.closest("#" + ESOLVER_SUBMIT_BTN_ID);
      if (!trigger) return;

      var nameField = document.getElementById(NAME_FIELD_ID);
      var waField = document.getElementById(WHATSAPP_FIELD_ID);
      var ccField = document.getElementById(WHATSAPP_CC_ID);

      if (!nameField || !waField) return; // BD visitor — কিছুই করার দরকার নেই

      var nameVal = nameField.value.trim();
      var waVal = waField.value.trim();

      if (!nameVal || !waVal) {
        e.preventDefault();
        e.stopImmediatePropagation();

        var wrapper = document.querySelector("[" + BLOCK_ATTR + "-wrapper]");
        var err = document.getElementById("ahm-expat-error");
        if (!err && wrapper) {
          err = document.createElement("div");
          err.id = "ahm-expat-error";
          err.style.cssText = "color:#d02222;font-size:13px;margin:0 0 12px;";
          err.textContent =
            "অনুগ্রহ করে প্রবাসীর নাম ও WhatsApp/IMO নম্বর দুটোই দিন।";
          wrapper.appendChild(err);
        }
        return;
      }

      var fullWhatsapp = waVal;
      if (ccField && waVal.indexOf("+") !== 0) {
        fullWhatsapp = ccField.value + " " + waVal;
        waField.value = fullWhatsapp;
      }

      // ============ eSolver-এর নিজস্ব Order Note field-এ তথ্য বসানো ============
      var esolverNoteField = document.getElementById(ESOLVER_NOTE_FIELD_ID);
      if (esolverNoteField) {
        var countryName = countryNameFromIso(resolvedCountryIso);
        var contactTypeVal =
          (document.getElementById(CONTACT_TYPE_ID) || {}).value ||
          "WhatsApp";
        var expatLine =
          "প্রবাসী তথ্য — নাম: " +
          nameVal +
          ", " +
          contactTypeVal +
          ": " +
          fullWhatsapp +
          ", Country: " +
          countryName;

        var existingCustomerNote = esolverNoteField.value.trim();
        esolverNoteField.value = existingCustomerNote
          ? existingCustomerNote + "\n" + expatLine
          : expatLine;

        esolverNoteField.dispatchEvent(new Event("input", { bubbles: true }));
        esolverNoteField.dispatchEvent(new Event("change", { bubbles: true }));
      }
      // ============================================================================

      // ============ মূল Customer Name field-এর শেষে country suffix ============
      var mainFields = getMainFieldContainers();
      var customerNameField =
        mainFields[0] && mainFields[0].querySelector("input, textarea");
      if (customerNameField) {
        var suffixCountryName = countryNameFromIso(resolvedCountryIso);
        var suffix = " (Order-Abroad-" + suffixCountryName + ")";
        var currentCustomerName = customerNameField.value.trim();
        if (
          currentCustomerName &&
          currentCustomerName.indexOf(suffix) === -1
        ) {
          customerNameField.value = currentCustomerName + suffix;
          customerNameField.dispatchEvent(
            new Event("input", { bubbles: true })
          );
          customerNameField.dispatchEvent(
            new Event("change", { bubbles: true })
          );
        }
      }
      // ============================================================================

      // preventDefault/stopPropagation করা হচ্ছে না — eSolver স্বাভাবিকভাবে
      // ক্লিক continue করে নিজের submit logic চালাবে
    },
    true
  );
})();
